<script setup lang="ts">
const documentId = inject("documentId") as any;
const thesaurusStore = useDocumentThesaurusStore(documentId);
const { isInitialized, pages, currentPage } = storeToRefs(thesaurusStore);
</script>

<template>
  <div class="flex flex-col h-full min-h-0">
    <BaseLoading v-if="!isInitialized" />
    <div
      v-if="isInitialized"
      class="flex flex-col h-full min-h-0"
      v-auto-animate
    >
      <DocumentEditorReviewPanelThesaurusBreadcrumbs v-if="pages.length > 1" />
      <div class="grow min-h-0 p-4 overflow-auto flex flex-col">
        <DocumentEditorReviewPanelThesaurusPagesHome
          v-if="currentPage.type == ThesaurusPageType.home"
        />
        <DocumentEditorReviewPanelThesaurusPagesBannedWords
          v-if="currentPage.type == ThesaurusPageType.bannedWords"
        />
        <DocumentEditorReviewPanelThesaurusPagesWord
          v-if="currentPage.type == ThesaurusPageType.word"
        />
        <DocumentEditorReviewPanelThesaurusPagesWordList
          v-if="currentPage.type == ThesaurusPageType.wordList"
        />
      </div>
    </div>
  </div>
</template>

<style scoped></style>
